function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * Please read this document for information about these utilities: https://applyboard.atlassian.net/wiki/spaces/APP/pages/2862612698/Aggregated+Page-Level+Data-fetching
 */
import { request, useMutation, useQuery, useQueryClient, getTraceId } from '@applyboard/ui-utils';
import { createContext, useContext } from 'react';
import { z } from 'zod';
import { ApplicationRequirementResponse, UserPermissionsSchema, AdminNoteResponse, CustomerNoteResponse, ApplicationNotesUserResponse, validateChecksMatchDefinitions } from "../../../types";
import { HttpError } from "../../../utils/error";
import { updateAggregatedDataCache } from "../../../data";
import { arrayFilterOutUnrecognized } from "../../../utils/zod";
import { EvaluationMetadata } from "../../../types/EvaluationMetadata";
import { RecruitmentPartnerResponse } from "../../../types/RecruitmentPartner";
import { OrderItemResponse } from "../../../types/OrderItem";
import { ApplicationNoticeResponse } from "../../../types/ApplicationNotice";
import { ProgramResponse, ExpectedEslProgramResponse } from "../../../types/Program";
import { StudentResponse } from "../../../types/Student";
import { SchoolResponse } from "../../../types/School";
import { ApplicationAvailableActionResponse } from "../../../types/ApplicationAvailableAction";
import { ApplicationWorkflowResponse } from "../../../types/ApplicationWorkflow";
import { InitialPropsResponse } from "../../../types/InitialProps";
import { FeatureFlagsResponse } from "../../../types/FeatureFlags";
import { CommissionResponse } from "../../../types/Commission";
import { IntakeResponse } from "../../../types/Intake";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var ApplicationProgram = z.object({
  programType: z.string(),
  alternateActualStartDate: z.string().nullish(),
  actualStartDate: z.string().nullish(),
  startDate: z.string().nullish(),
  submissionDeadline: z.string().nullish(),
  programId: z.number()
});
var AggregatedDataApplication = z.object({
  paidAt: z.string().nullish(),
  student: z.object({
    id: z.number(),
    fullName: z.string()
  }),
  stageId: z.string(),
  legacyId: z.number(),
  newView: z["boolean"]().nullish(),
  newViewReleaseDate: z.string().nullish(),
  programs: ApplicationProgram.array(),
  legacyRpUserId: z.number().nullish(),
  rpFullName: z.string().nullish(),
  backupPrograms: z.array(z.number()),
  instantSubmissionEnabled: z["boolean"]().nullish(),
  flags: z.object({
    enrollmentConfirmed: z["boolean"]().nullish(),
    instantSubmissionEnabled: z["boolean"]().nullish()
  }),
  cancellationReasonKey: z.string().nullish(),
  cancellationReasonNote: z.string().nullish()
});
export var legacyApplicationRequirementTypes = ['application_document_requirements', 'application_questions_requirements', 'application_payment_requirements', 'application_receipt_requirements', 'application_disclaimer_requirements', 'application_hybrid_requirements'];
var LegacyApplicationRequirementTypeSchema = z["enum"](legacyApplicationRequirementTypes);
var AggregatedDataItem = z.discriminatedUnion('type', [ApplicationRequirementResponse, SchoolResponse, ProgramResponse, ExpectedEslProgramResponse, StudentResponse, RecruitmentPartnerResponse, CustomerNoteResponse, AdminNoteResponse, ApplicationNotesUserResponse, ApplicationNoticeResponse, ApplicationAvailableActionResponse, z.object({
  type: z.literal('application'),
  id: z.string(),
  attributes: AggregatedDataApplication
}), OrderItemResponse, EvaluationMetadata, ApplicationWorkflowResponse, FeatureFlagsResponse, UserPermissionsSchema, CommissionResponse, IntakeResponse,
// --- LEGACY DATA STRUCTURES ---
InitialPropsResponse, z.object({
  type: z.literal('application_step')
})
// TODO: remove this passthrough / type assertion
.passthrough(), z.object({
  type: z.literal('legacy_application')
})
// TODO: remove this passthrough / type assertion
.passthrough(), z.object({
  type: LegacyApplicationRequirementTypeSchema
}).passthrough(), z.object({
  type: z.literal('application_configuration')
}).passthrough(), z.object({
  type: z.literal('application_requirement_evaluation_status')
}).passthrough()]);
var AggregatedDataItems = arrayFilterOutUnrecognized(AggregatedDataItem).superRefine(validateChecksMatchDefinitions);
var AggregatedDataResponse = z.object({
  included: AggregatedDataItems,
  meta: z.object({
    dateGenerated: z.string()
  })
}).passthrough();
export var AggregatedData = z.object({
  response: AggregatedDataResponse,
  traceId: z.string().nullish()
});
var ApplicationDataContext = /*#__PURE__*/createContext(null);

/**
 * @param props.applicationId The application ID of the current page
 * @note This should ONLY wrap the application detail page and no other page
 */
export function ApplicationDetailPageDataProvider(props) {
  return _jsx(ApplicationDataContext.Provider, {
    value: props.applicationId,
    children: props.children
  });
}
export function useApplicationId() {
  var appId = useContext(ApplicationDataContext);
  if (appId === null) {
    throw new Error('application data hooks can not be used outside the application page, because the responses are optimized for the application page alone');
  }
  return appId;
}

/**
 * Fetches and returns the aggregated data for the application detail page
 *
 * @note Please read this document for information: https://applyboard.atlassian.net/wiki/spaces/APP/pages/2862612698/Aggregated+Page-Level+Data-fetching
 */
export function useApplicationPageAggregatedData(options) {
  var appId = useApplicationId();
  return useQuery(generateAggregatedDataQueryKey(appId), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return request( // TODO: replace the URL parameters with query parameters like the ones used
          // in RoadRunnerDashboard and RequirementPage
          "/api/awa/pages/applications/".concat(appId, "/aggregated-data"), {
            // Forces `request` util to get/use an access token.  This needs to be
            // done for the 1st request on the page (e.g. our aggregated data is
            // one of the first requests), but it will use the access token
            // without this flag set for subsequent requests.  We want to move
            // away from using cookies in the BFF but before we do that we need to
            // pass the access token via the authorization header for all requests
            // to the BFF
            allowAnonymous: false,
            schema: AggregatedData,
            throwError: handleError,
            getData: function () {
              var _getData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res, req) {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return res.json();
                    case 2:
                      _context.t0 = _context.sent;
                      _context.t1 = getTraceId(req);
                      return _context.abrupt("return", {
                        response: _context.t0,
                        traceId: _context.t1
                      });
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function getData(_x, _x2) {
                return _getData.apply(this, arguments);
              }
              return getData;
            }()
          });
        case 2:
          response = _context2.sent;
          return _context2.abrupt("return", response);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), {
    cacheTime: 0,
    refetchOnMount: false,
    onError: options.onError,
    retry: function retry(failureCount, error) {
      if (failureCount >= 2) {
        return false;
      }
      if (error instanceof HttpError && error.httpCode >= 500) {
        return true;
      }
      if (!(error instanceof HttpError)) {
        return true;
      }
      return false;
    },
    select: function (_select) {
      function select(_x3) {
        return _select.apply(this, arguments);
      }
      select.toString = function () {
        return _select.toString();
      };
      return select;
    }(function (data) {
      try {
        return options.select(data.response);
      } catch (err) {
        if (err instanceof Error && data.traceId) {
          Object.assign(err, {
            traceId: data.traceId
          });
        }
        throw err;
      }
    }),
    refetchInterval: options.refetchInterval,
    useErrorBoundary: true,
    enabled: options.enabled
  });
}

/**
 * Performs a mutation against the application detail page.  Automatically
 * updates the client-side store of aggregated data when the mutation succeeds,
 * so the page is kept up to date and consistent with itself
 *
 * @note Please read this document for information: https://applyboard.atlassian.net/wiki/spaces/APP/pages/2862612698/Aggregated+Page-Level+Data-fetching
 */
export function useApplicationPageMutation(callback) {
  var appId = useApplicationId();
  var queryClient = useQueryClient();
  return useMutation(function (mutationParams) {
    var mutationConfig = callback(mutationParams);
    return request("/api/awa/pages/applications/".concat(appId, "/data").concat(mutationConfig.url), {
      method: mutationConfig.method,
      schema: AggregatedData,
      body: mutationConfig.body,
      etag: mutationConfig.etag,
      allowAnonymous: false,
      throwError: handleError,
      getData: function () {
        var _getData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res, req) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return res.json();
              case 2:
                _context3.t0 = _context3.sent;
                _context3.t1 = getTraceId(req);
                return _context3.abrupt("return", {
                  response: _context3.t0,
                  traceId: _context3.t1
                });
              case 5:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function getData(_x4, _x5) {
          return _getData2.apply(this, arguments);
        }
        return getData;
      }()
    });
  }, {
    onSuccess: function onSuccess(newData) {
      updateAggregatedDataCache({
        newData: newData,
        queryKey: generateAggregatedDataQueryKey(appId),
        queryClient: queryClient
      });
    }
  });
}

/**
 * Temporary function to reload aggregated data.  This won't be needed once all
 * our mutations use useApplicationPageMutation
 *
 * @note Please read this document for information: https://applyboard.atlassian.net/wiki/spaces/APP/pages/2862612698/Aggregated+Page-Level+Data-fetching
 */
export function useReloadApplicationPageAggregatedData() {
  var appId = useApplicationId();
  var queryClient = useQueryClient();
  var _useMutation = useMutation(function () {
      return request("/api/awa/pages/applications/".concat(appId, "/aggregated-data?omitInitialProps=true"), {
        schema: AggregatedData,
        allowAnonymous: false,
        getData: function () {
          var _getData3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(res, req) {
            return _regeneratorRuntime().wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return res.json();
                case 2:
                  _context4.t0 = _context4.sent;
                  _context4.t1 = getTraceId(req);
                  return _context4.abrupt("return", {
                    response: _context4.t0,
                    traceId: _context4.t1
                  });
                case 5:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }));
          function getData(_x6, _x7) {
            return _getData3.apply(this, arguments);
          }
          return getData;
        }()
      });
    }, {
      onSuccess: function onSuccess(newData) {
        updateAggregatedDataCache({
          newData: newData,
          queryKey: generateAggregatedDataQueryKey(appId),
          queryClient: queryClient
        });
      }
    }),
    mutate = _useMutation.mutate;
  return {
    reloadApplicationPageAggregatedData: mutate
  };
}
export function generateAggregatedDataQueryKey(appId) {
  return ['aggregatedData', {
    id: appId,
    pkg: 'ab-application'
  }];
}
export function getAggregatedData(_ref2) {
  var appId = _ref2.appId,
    queryClient = _ref2.queryClient;
  var queryKey = generateAggregatedDataQueryKey(appId);
  var data = queryClient.getQueryData(queryKey);
  return AggregatedData.nullish().parse(data);
}
export var emptyObject = Object.freeze({});
function handleError(_x8) {
  return _handleError.apply(this, arguments);
}
function _handleError() {
  _handleError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
    var _data, response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (!(typeof (res === null || res === void 0 ? void 0 : res.status) === 'number')) {
            _context5.next = 12;
            break;
          }
          _context5.prev = 1;
          _context5.next = 4;
          return res.json();
        case 4:
          _data = _context5.sent;
          _context5.next = 10;
          break;
        case 7:
          _context5.prev = 7;
          _context5.t0 = _context5["catch"](1);
          throw new HttpError({
            httpCode: res.status
          });
        case 10:
          response = z.object({
            message: z.string()
          }).safeParse(_data);
          throw new HttpError({
            httpCode: res.status,
            message: response.success ? response.data.message : undefined
          });
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 7]]);
  }));
  return _handleError.apply(this, arguments);
}